import { useCallback, useEffect, useState } from "react"
import useSWR from "swr"
import { discoveryColors } from '../../../utils/constants'
import { getColumnsOfDatasets } from '../../../utils/tools'

const useDatasets = (ticker) => {
    const { data: rawDatasets } = useSWR(ticker && `/api/datasets?ticker=${ticker}`)
    const [ datasets, setDatasets ] = useState()

    useEffect(() => {setDatasets(rawDatasets?.map(data => ({...data, color: discoveryColors[Math.floor(Math.random()*discoveryColors.length)]})));return () => {}} ,[rawDatasets])
    
    const updateMonthlyChange = useCallback((dataset, column, change) => {
        setDatasets(data => data?.map(datasetField => ({
            ...datasetField, 
            ...(datasetField.value === dataset && { columns: datasetField.columns.map(columnField => ({
                ...columnField,
                ...(columnField.value === column && {monthly_change: change})
            }))})
        })))
    },[]) 

    const getColumns = useCallback((datasetValue) => getColumnsOfDatasets(datasetValue, datasets),[datasets])

    return {
        datasets,
        updateMonthlyChange,
        getColumns
    }
}

export default useDatasets